import { Skeleton } from '@travel/ui';

import styles from './skeleton.module.scss';

function SkeletonPage() {
  return (
    <div className={styles.skeletonWrapper}>
      <Skeleton width="100%" height="45px" />

      <Skeleton className={styles.paragraphSkeleton} length={'long'} type={'paragraph'} />
      <div className={styles.items}>
        <Skeleton height="150px" />
        <Skeleton className={styles.roomInfoSkeleton} length={'long'} type={'paragraph'} />
      </div>
      <Skeleton className={styles.paragraphSkeleton} length={'long'} type={'paragraph'} />
    </div>
  );
}

export default SkeletonPage;
